<script setup lang="ts">
import {useSite} from '../store';
import Button from './Button.vue';
defineProps<{loading?:boolean;missing?:boolean}>();
defineEmits<{retry:[]}>();
const site=useSite();
</script>
<template><section class="page-state" aria-live="polite"><div v-if="loading" class="loading-line"></div><h1>{{site.text(loading?'loading':missing?'not_found':'load_error')||(loading?'加载中':'暂时无法加载内容')}}</h1><template v-if="!loading"><Button v-if="missing" to="/">{{site.text('back_home')}}</Button><Button v-else @click="$emit('retry')">{{site.text('retry')||'重新加载'}}</Button></template></section></template>
